import type { GetAllCseResponse } from "@/core/types/(api)/cse";
import type { GetAllCsmResponse } from "@/core/types/(api)/csm";

export function adaptCsmData(items: GetAllCsmResponse, search: string) {
  return items
    .filter((csm) => matchesSearch(csm, search))
    .sort((a, b) => (a.name > b.name ? 1 : -1))
    .map((csm) => ({ id: csm.username, ...csm }));
}

export type AdaptedCsmRow = ReturnType<typeof adaptCsmData>[number];

export function adaptCseData(items: GetAllCseResponse, search: string) {
  return items
    .filter((cse) => cse.status !== "INACTIVE") // missing status == active (backend convention)
    .filter((cse) => matchesSearch(cse, search))
    .sort((a, b) => (a.name > b.name ? 1 : -1))
    .map((cse) => ({ id: cse.username, ...cse }));
}

export type AdaptedCseRow = ReturnType<typeof adaptCseData>[number];

function matchesSearch({ email, name }: { email: string; name: string }, search: string) {
  return (
    name.toLowerCase().includes(search.toLowerCase()) ||
    email.toLowerCase().includes(search.toLowerCase())
  );
}
